/* global axios */
import AsteriskApiClient from './index';

class IvrsAPI extends AsteriskApiClient {
  constructor() {
    super('ivrs');
  }

  // GET /api/v1/accounts/:account_id/asterisk/ivrs
  get(params = {}) {
    return axios.get(this.url, { params });
  }

  // GET /api/v1/accounts/:account_id/asterisk/ivrs/:id
  show(id) {
    return axios.get(`${this.url}/${encodeURIComponent(id)}`);
  }

  // POST /api/v1/accounts/:account_id/asterisk/ivrs
  create(data) {
    return axios.post(this.url, data);
  }

  // PUT /api/v1/accounts/:account_id/asterisk/ivrs/:id
  update(id, data) {
    return axios.put(`${this.url}/${encodeURIComponent(id)}`, data);
  }

  // DELETE /api/v1/accounts/:account_id/asterisk/ivrs/:id
  delete(id) {
    return axios.delete(`${this.url}/${encodeURIComponent(id)}`);
  }
}

export default new IvrsAPI();
